
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type fitmentTableRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableRT(): TemplateResult<fitmentTableRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function scopeNotes1() {
                    var notes = Object.entries(this.fitment).find(([field]) => field === 'Notes')?.[1];
                    return _createElement('li', { 'className': 'fitment-table-item' }, _createElement('span', { 'className': 'fitment-table-vehicle' }, '\n            ', Object.entries(this.fitment).filter(([field, value]) => field !== 'Notes' && value).map(([, value]) => value).join(' '), '\n          '), _createElement('br', {}), notes ? _createElement('span', {
                        'className': 'fitment-table-notes',
                        'key': '406'
                    }, notes) : null);
                }
                return scopeNotes1.apply(this, []);
            }, { count: undefined })];
    }
    return this.vehicleSpecific || this.manyFitments ? _createElement('details', {
        'className': 'disclosure disclosure--row cm_fitment-table fitment-table-container',
        'key': '0'
    }, _createElement('summary', {}, _createElement('div', { 'className': 'flex justify-between items-center' }, _createElement('h2', { 'className': 'disclosure__title h5 mb-0' }, 'Fitment Data'), _createElement('span', { 'className': 'disclosure__toggle' }, _createElement('svg', {
        'width': '24',
        'height': '24',
        'viewBox': '0 0 24 24',
        'aria-hidden': 'true',
        'focusable': 'false',
        'role': 'presentation',
        'className': 'icon'
    }, _createElement('path', {
        'd': 'M20 8.5 12.5 16 5 8.5',
        'stroke': 'currentColor',
        'stroke-width': '1.5',
        'fill': 'none'
    }))))), _createElement('div', { 'className': 'disclosure__panel has-motion' }, _createElement('div', { 'className': 'disclosure__content rte' }, _createElement.apply(this, [
        'ul',
        { 'className': 'fitment-table-body cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ])))) : null;
}
        export const componentNames = []